export default __webpack_public_path__ + "static/media/bnsf2.833a5eca.svg";